const initialState = {
  loading: false,
  totalSupply: 0,
  isPsEnabled: false,
  isWlEnabled: false,
  isVipEnabled: false,
  isFreeEnabled: false,
  maxMintsPerPS: 0,
  error: false,
  errorMsg: "",
};



const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CHECK_DATA_REQUEST":
      return {
        ...state,
        loading: true,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_SUCCESS":
      return {
        ...state,
        loading: false,
        totalSupply: action.payload.totalSupply,
        isPsEnabled: action.payload.isPsEnabled,
        isWlEnabled: action.payload.isWlEnabled,
        isVipEnabled: action.payload.isVipEnabled,
        isFreeEnabled: action.payload.isFreeEnabled,
        maxMintsPerPS: action.payload.maxMintsPerPS,
        // cost: action.payload.cost,
        error: false,
        errorMsg: "",
      };
    case "CHECK_DATA_FAILED":
      return {
        ...initialState,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    default:
      return state;
  }
};

export default dataReducer;
